<app-page-heading [key]="'tnx-dashboard.title'">
</app-page-heading>

<div class="main-content tnx-dashboard">
    <app-data-table [columns]="columns"
                    [additionalRowTemplate]="eventRow"
                    [additionalInfoKey]="'events'"
                    [showColumnsSelection]="false"
                    [loadPage]="loadPage"
                    [(filters)]="criteria"
                    [filtersComponent]="dataFilter"
                    [loadAtStartup]="false"
                    [allowMultiItemSelection]="true"
                    [selectOnRowClick]="false"
                    [noOverflow]="true"
                    [lightSkin]="true"
                    (onReset)="resetFilters()">
        <app-data-filters #dataFilter [fullWidth]="true"
                          [opened]="true"
                          [titleKey]="'tnx-dashboard.filters.title'"
                          [showTitle]="true">
            <app-data-filter-group class="main-group" style="flex: 1;">
                <app-data-filter-group [spaceAuto]="true">
                    <app-data-filter-multi-string-input [labelKey]="'tnx-dashboard.filters.labels.load-id'"
                                                        [(model)]="criteria.loadIds"
                                                        (modelChange)="filterMode = FilterMode.CUSTOM">
                    </app-data-filter-multi-string-input>
                    <app-data-filter-multi-string-input [labelKey]="'tnx-dashboard.filters.labels.delivery-number'"
                                                        [(model)]="criteria.deliveryNumbers"
                                                        (modelChange)="filterMode = FilterMode.CUSTOM">
                    </app-data-filter-multi-string-input>
                    <app-data-filter-select [labelKey]="'tnx-dashboard.filters.labels.status'"
                                            [(model)]="criteria.status"
                                            [options]="statusOptions"
                                            (modelChange)="filterMode = FilterMode.CUSTOM">
                    </app-data-filter-select>
                    <app-data-filter-input [labelKey]="'tnx-dashboard.filters.labels.origin-country'"
                                           [(model)]="criteria.originCountryCode"
                                           (modelChange)="filterMode = FilterMode.CUSTOM">
                    </app-data-filter-input>
                    <app-data-filter-input [labelKey]="'tnx-dashboard.filters.labels.destination-country'"
                                           [(model)]="criteria.destinationCountryCode"
                                           (modelChange)="filterMode = FilterMode.CUSTOM">
                    </app-data-filter-input>
                </app-data-filter-group>

                <app-data-filter-group class="space-top-15 filterDates" [spaceAuto]="true">
                   <app-data-filter-group>
                       <app-data-filter-date [labelKey]="'tnx-dashboard.filters.labels.assignment-deadline'"
                                             [(model)]="criteria.assignmentDeadlineAfter"
                                             (modelChange)="filterMode = FilterMode.CUSTOM">
                       </app-data-filter-date>
                       <app-data-filter-date [labelKey]="'tnx-dashboard.filters.labels.and'"
                                             [(model)]="criteria.assignmentDeadlineBefore"
                                             (modelChange)="filterMode = FilterMode.CUSTOM">
                       </app-data-filter-date>
                   </app-data-filter-group>
                    <app-data-filter-group>
                        <app-data-filter-date [labelKey]="'tnx-dashboard.filters.labels.last-event'"
                                              [(model)]="criteria.lastEventAfter"
                                              (modelChange)="filterMode = FilterMode.CUSTOM">
                        </app-data-filter-date>
                        <app-data-filter-date [labelKey]="'tnx-dashboard.filters.labels.and'"
                                              [(model)]="criteria.lastEventBefore"
                                              (modelChange)="filterMode = FilterMode.CUSTOM">
                        </app-data-filter-date>
                    </app-data-filter-group>
                </app-data-filter-group>
            </app-data-filter-group>
        </app-data-filters>
        <app-data-buttons>
            <div class="counters-btn">
                <div class="counter-filter FAILED" [class._selected]="filterMode === FilterMode.FAILURE"
                     (click)="switchFilterMode(FilterMode.FAILURE)">
                    <span class="counter">{{ metricResults.failed }}</span>&nbsp;
                    <span class="counter-label" [i18n]="'tnx-dashboard.counters.failure'"></span>
                </div>
                <div class="counter-filter EXPIRING" [class._selected]="filterMode === FilterMode.EXPIRING"
                     (click)="switchFilterMode(FilterMode.EXPIRING)">
                    <span class="counter">{{ metricResults.aboutToExpire }}</span>&nbsp;
                    <span class="counter-label" [i18n]="'tnx-dashboard.counters.expiring'"></span>
                </div>
                <div class="counter-filter CANCELED" [class._selected]="filterMode === FilterMode.CANCELLED"
                     (click)="switchFilterMode(FilterMode.CANCELLED)">
                    <span class="counter">{{ metricResults.canceled }}</span>&nbsp;
                    <span class="counter-label" [i18n]="'tnx-dashboard.counters.canceled'"></span>
                </div>
                <div class="counter-filter UPDATED" [class._selected]="filterMode === FilterMode.UPDATED"
                     (click)="switchFilterMode(FilterMode.UPDATED)">
                    <span class="counter">{{ metricResults.updated }}</span>&nbsp;
                    <span class="counter-label" [i18n]="'tnx-dashboard.counters.updated'"></span>
                </div>
            </div>
        </app-data-buttons>
    </app-data-table>
</div>

<ng-template #loadColumn
             let-loadId="loadId"
             let-deliveryNumbers="deliveryNumbers"
             let-assignmentDeadline="assignmentDeadline"
             let-status=status
             let-lastOperationStatus="lastOperationStatus">
    <div class="loads-numbers" [ngClass]="{
            FAILED: lastOperationStatus === ExecutionStatus.FAILED,
            EXPIRING: isAboutToExpire(assignmentDeadline),
            CANCELED: status === TnxLoadStatus.CANCELED,
            UPDATED: status === TnxLoadStatus.UPDATED
        }">
        <a class="load-number cmaweb-link" [href]="link.goToLoadManagementForLoad(loadId)"
           target="_blank">{{ loadId }}</a>
        <a class="delivery-number cmaweb-link" [href]="link.goToLoadManagementForDelivery(deliveryNumbers.join(','))"
           target="_blank">{{ deliveryNumbers.join(', ') }}</a>
    </div>
</ng-template>

<ng-template #locationsColumn
             let-originLocationName="originLocationName"
             let-originCountryCode="originCountryCode"
             let-destinationLocationName="destinationLocationName"
             let-destinationCountryCode="destinationCountryCode">
    <div>
        <div>
            <a class="cmaweb-link" *ngIf="canManageLocations" [href]="link.goToLocationName(originLocationName)"
               target="_blank">{{ originLocationName }}</a>
            <span *ngIf="!canManageLocations">{{ originLocationName }}</span>
            &nbsp;- ({{ originCountryCode }})
        </div>
        <div>
            <a class="cmaweb-link" *ngIf="canManageLocations" [href]="link.goToLocationName(destinationLocationName)"
               target="_blank">{{ destinationLocationName }}</a>
            <span *ngIf="!canManageLocations">{{ destinationLocationName }}</span>
            &nbsp;- ({{ destinationCountryCode }})
        </div>
    </div>
</ng-template>

<ng-template #assignmentDeadlineColumn let-assignmentDeadline="assignmentDeadline">
    {{ assignmentDeadline | date : 'dd/MM/yyyy - HH:mm' }}
</ng-template>

<ng-template #lastEventDateColumn let-lastEventAt="lastEventAt">
    {{ lastEventAt | date : 'dd/MM/yyyy - HH:mm' }}
</ng-template>

<ng-template #tnxAcknowledgementDateColumn let-faSystemAcknowledgedAt="faSystemAcknowledgedAt">
    {{ faSystemAcknowledgedAt | date : 'dd/MM/yyyy - HH:mm' }}
</ng-template>

<ng-template #statusColumn let-status="status">
    <span class="status">{{ status }}</span>
</ng-template>

<ng-template #resultColumn let-lastOperationStatus="lastOperationStatus" let-loadUuid="loadUuid">
    <span class="result" [ngClass]="lastOperationStatus">{{ lastOperationStatus }}</span>

    <div class="collapseAction">
        <button class="collapseAction-btn" (click)="toggleDisplayEvents(loadUuid)">
            <i class="fas fa-chevron-down" *ngIf="!isSelectedLoad(loadUuid)"></i>
            <i class="fas fa-chevron-up" *ngIf="isSelectedLoad(loadUuid)"></i>
        </button>
    </div>
</ng-template>

<ng-template #eventRow let-info="info" let-i="index">
    <td class="infoNumber">
        <span class="infoNumber-item">{{i + 1}}</span>
    </td>
    <td class=infoAction>
        <div class="actionsList">
            <span *ngIf="info.type === TnxLoadEventType.AWARDED" class="actionsList-label"
                  [i18n]="'tnx-dashboard.table.event.input-tnx-to-by'"></span>
            <span *ngIf="info.type !== TnxLoadEventType.AWARDED" class="actionsList-label"
                  [i18n]="'tnx-dashboard.table.event.input-by-to-tnx'"></span>
            <div class="button-container" *ngIf="info.inputPayload != null">
                <button class="btn btn-primary btn-sm m-r-sm" (click)="openContextualData(info.inputPayload)">
                    <i class="fa fa-external-link-alt"></i>
                </button>
                <button class="btn btn-default btn-sm" (click)="copyJson(info.inputPayload)">
                    <i class="fa fa-copy"></i>
                </button>
            </div>
        </div>
    </td>
    <td class="infoType">{{ info.type }}</td>
    <td class="infoStatus"><span class="status" [ngClass]="info.computedStatus">{{ info.computedStatus }}</span></td>
    <td class="infoDate">{{ info.happenedAt | date : 'dd/MM/yyyy - HH:mm:ss' }}</td>
    <td class="infoContent">
        <ng-container *ngIf="info.acknowledgedAt; else notAcknowledged">
            <ng-container *ngIf="info.computedStatus === ExecutionStatus.SUCCEED; else statusFailed">
                <div class="load-event-ack-succeed"
                     [i18n]="[{target: 'innerHTML', key: 'tnx-dashboard.table.event.acknowledgement-succeed', params: { date : (info.acknowledgedAt | date : 'dd/MM/yyyy - HH:mm') } }]"></div>
            </ng-container>
            <ng-template #statusFailed>
                <div class="load-event-ack-failed"
                     [i18n]="'tnx-dashboard.table.event.acknowledgement-failed'"></div>
                <div *ngIf="info.errorMessage != null; else withoutErrorMessage" class="load-event-ack-error-message"
                     [i18n]="[{target: 'innerHTML', key: 'tnx-dashboard.table.event.acknowledgement-error-message', params: { errorMessage: info.errorMessage } }]">
                </div>
                <ng-template #withoutErrorMessage>
                    <div class="load-event-ack-error-message"
                         [i18n]="'tnx-dashboard.table.event.acknowledgement-no-error-message'">
                    </div>
                </ng-template>
            </ng-template>
        </ng-container>
        <ng-template #notAcknowledged>
            <ng-container
                *ngIf="info.errorMessage != null; else withoutError">
                <ng-container
                    *ngIf="!info.acknowledgedAt && info.computedStatus === ExecutionStatus.FAILED">
                    <div class="load-event-ack-error-message"
                         [i18n]="getTnxErrorContextTranslation(info.errorContext)"></div>
                    <div class="load-event-ack-error-message"
                         [i18n]="[{
                        target: 'innerHTML',
                        key: 'tnx-dashboard.table.event.error-message.@error',
                        params: {technicalError: info.errorMessage}
                     }]">
                    </div>
                </ng-container>
                <ng-container *ngIf="info.computedStatus === ExecutionStatus.SUCCEED">
                    <div class="load-event-ack-warning-message text">
                        <i class="fa fa-warning"></i>&nbsp;
                        <span [i18n]="'tnx-dashboard.table.event.output-tnx-to-by'"></span>
                    </div>
                    <div class="load-event-ack-warning-message"
                         [i18n]="[{target: 'innerHTML', key: 'tnx-dashboard.table.event.error-message.@error', params: {technicalError: info.errorMessage}}]">
                    </div>
                </ng-container>
            </ng-container>
            <ng-template #withoutError>
                <ng-container *ngIf="info.type === TnxLoadEventType.CREATED && !info.acknowledgedAt && info.computedStatus === ExecutionStatus.SUCCEED">
                    <div class="load-event-ack-pending" [i18n]="'tnx-dashboard.table.event.acknowledgement-pending'"></div>
                </ng-container>
                <ng-container *ngIf="info.type ===TnxLoadEventType.AWARDED && info.computedStatus === ExecutionStatus.SUCCEED">
                    <span [i18n]="'tnx-dashboard.table.event.awarded-succeed'"></span>;
                </ng-container>
            </ng-template>
        </ng-template>
    </td>
    <td class="infoCarrier">
        <div class="event-carrier" >
            <ng-container *ngIf="info.awardedCarrier">
                <a class="cmaweb-link" *ngIf="info.awardedCarrier && canManageCarriers"
                   [href]="link.goToCarrierCode(info.awardedCarrier.code, false)"
                   target="_blank">{{ info.awardedCarrier.name }}</a>
                <span *ngIf="info.awardedCarrier && !canManageCarriers">{{ info.awardedCarrier.name }}</span>
            </ng-container>
        </div>
    </td>
    <td>
        <div class="actionsList" >
            <ng-container *ngIf="info.outputPayload">
                <span *ngIf="info.type === TnxLoadEventType.AWARDED" class="actionsList-label"
                      [i18n]="'tnx-dashboard.table.event.output-tnx-to-by'"></span>
                <span *ngIf="info.type !== TnxLoadEventType.AWARDED" class="actionsList-label"
                      [i18n]="'tnx-dashboard.table.event.output-by-to-tnx'"></span>
                <div class="button-container">
                    <button class="btn btn-primary btn-sm m-r-sm" (click)="openContextualData(info.outputPayload)">
                        <i class="fa fa-external-link-alt"></i>
                    </button>
                    <button class="btn btn-default btn-sm" (click)="copyJson(info.outputPayload)">
                        <i class="fa fa-copy"></i>
                    </button>
                </div>
            </ng-container>
        </div>
    </td>
</ng-template>

<ng-template #empty>
    <span class="force-font-italic" [i18n]="'tnx-dashboard.table.event.empty'"></span>
</ng-template>

<ng-template #loadColumnTitle>
    <span style="display: block; line-height: 0; padding-top: 8px;" [i18n]="'tnx-dashboard.table.load'"></span>
    <span style="display: block; line-height: 15px; padding-top: 8px;"
          [i18n]="'tnx-dashboard.table.delivery-number'"></span>
</ng-template>

<ng-template #originAndDestinationColumnTitle>
    <span style="display: block; line-height: 0; padding-top: 8px;" [i18n]="'tnx-dashboard.table.origin'"></span>
    <span style="display: block; line-height: 15px; padding-top: 8px;"
          [i18n]="'tnx-dashboard.table.destination'"></span>
</ng-template>

<ng-template #assignmentDeadlineColumnTitle>
    <span [i18n]="'tnx-dashboard.table.assignment-deadline'"></span>&nbsp;
    <a [i18n]="[{target: 'attribute:title', key: 'tnx-dashboard.table.assignment-deadline-help'}]"><i
        class="fa fa-info-circle"></i></a>
</ng-template>

